export const blueFullValue = '#1890FF';
export const greenFullValue = '#52C41A';
export const redFullValue = '#DD1D1D';
export const yellowFullValue = '#FADB14';
